import { ActionsUnion, createAction } from "store/helper";

import {
  IEntityFetchCollectionFailure,
  IEntityFetchCollectionSuccess,
  RequestAction,
  createRequestTypes,
} from "../actions";

import { ISpamEntry } from "./interfaces";

export const SpamActionNames = {
  FETCH_TRUSTED_LIST: createRequestTypes("ENTITIES/SPAM/FETCH_TRUSTED_LIST"),
  FETCH_BLOCKED_LIST: createRequestTypes("ENTITIES/SPAM/FETCH_BLOCKED_LIST"),
  ADD_TRUSTED_ENTRY: createRequestTypes("ENTITIES/SPAM/ADD_TRUSTED_ENTRY"),
  ADD_BLOCKED_ENTRY: createRequestTypes("ENTITIES/SPAM/ADD_BLOCKED_ENTRY"),
  REMOVE_TRUSTED_ENTRY: createRequestTypes("ENTITIES/SPAM/REMOVE_TRUSTED_ENTRY"),
  REMOVE_BLOCKED_ENTRY: createRequestTypes("ENTITIES/SPAM/REMOVE_BLOCKED_ENTRY"),
  SYNC_BLOCKED_DELETE: "ENTITIES/SPAM/SYNC_BLOCKED_DELETE",
  SYNC_TRUSTED_DELETE: "ENTITIES/SPAM/SYNC_TRUSTED_DELETE",
  QUEUED_ADD_TRUSTED_ENTRIES: "ENTITIES/SPAM/QUEUED_ADD_TRUSTED_ENTRIES",
  QUEUED_ADD_BLOCKED_ENTRIES: "ENTITIES/SPAM/QUEUED_ADD_BLOCKED_ENTRIES",
  QUEUED_ADD_BLOCKED_ENTRIES_DONE: "ENTITIES/SPAM/QUEUED_ADD_BLOCKED_ENTRIES_DONE",
  QUEUED_ADD_TRUSTED_ENTRIES_DONE: "ENTITIES/SPAM/QUEUED_ADD_TRUSTED_ENTRIES_DONE",
};

export const SpamActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchTrustedList: () => createAction(SpamActionNames.FETCH_TRUSTED_LIST[RequestAction.REQUEST], {}),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchTrustedListSuccess: (payload: IEntityFetchCollectionSuccess<ISpamEntry>) =>
    createAction(SpamActionNames.FETCH_TRUSTED_LIST[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchTrustedListFailure: (payload: IEntityFetchCollectionFailure) =>
    createAction(SpamActionNames.FETCH_TRUSTED_LIST[RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchBlockedList: () => createAction(SpamActionNames.FETCH_BLOCKED_LIST[RequestAction.REQUEST], {}),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchBlockedListSuccess: (payload: IEntityFetchCollectionSuccess<ISpamEntry>) =>
    createAction(SpamActionNames.FETCH_BLOCKED_LIST[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchBlockedListFailure: (payload: IEntityFetchCollectionFailure) =>
    createAction(SpamActionNames.FETCH_BLOCKED_LIST[RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  addTrustedEntry: (payload: { entry: string }) =>
    createAction(SpamActionNames.ADD_TRUSTED_ENTRY[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  addTrustedEntrySuccess: (payload: ISpamEntry) =>
    createAction(SpamActionNames.ADD_TRUSTED_ENTRY[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  addTrustedEntryFailure: ({ duplicated = false, type }: any) =>
    createAction(SpamActionNames.ADD_TRUSTED_ENTRY[RequestAction.FAILURE], { duplicated, type }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  addBlockedEntry: (payload: { entry: string }) =>
    createAction(SpamActionNames.ADD_BLOCKED_ENTRY[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  addBlockedEntrySuccess: (payload: ISpamEntry) =>
    createAction(SpamActionNames.ADD_BLOCKED_ENTRY[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  addBlockedEntryFailure: ({ duplicated = false, type }: any) =>
    createAction(SpamActionNames.ADD_BLOCKED_ENTRY[RequestAction.FAILURE], { duplicated, type }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  removeTrustedEntry: (payload: { id: string }) =>
    createAction(SpamActionNames.REMOVE_TRUSTED_ENTRY[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  removeTrustedEntrySuccess: () => createAction(SpamActionNames.REMOVE_TRUSTED_ENTRY[RequestAction.SUCCESS], {}),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  removeTrustedEntryFailure: () => createAction(SpamActionNames.REMOVE_TRUSTED_ENTRY[RequestAction.FAILURE], {}),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  removeBlockedEntry: (payload: { id: string }) =>
    createAction(SpamActionNames.REMOVE_BLOCKED_ENTRY[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  removeBlockedEntrySuccess: () => createAction(SpamActionNames.REMOVE_BLOCKED_ENTRY[RequestAction.SUCCESS], {}),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  removeBlockedEntryFailure: () => createAction(SpamActionNames.REMOVE_BLOCKED_ENTRY[RequestAction.FAILURE], {}),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  queuedAddTrustedEntries: ({ requesterEmails }: any) =>
    createAction(SpamActionNames.QUEUED_ADD_TRUSTED_ENTRIES, { requesterEmails }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  queuedAddBlockedEntries: ({ requesterEmails }: any) =>
    createAction(SpamActionNames.QUEUED_ADD_BLOCKED_ENTRIES, { requesterEmails }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  queuedAddBlockedEntriesDone: (successCount: number, failureCount: number) =>
    createAction(SpamActionNames.QUEUED_ADD_BLOCKED_ENTRIES_DONE, { successCount, failureCount }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  queuedAddTrustedEntriesDone: (successCount: number, failureCount: number) =>
    createAction(SpamActionNames.QUEUED_ADD_TRUSTED_ENTRIES_DONE, { successCount, failureCount }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncBlockedDelete: (payload: { id: string }) => createAction(SpamActionNames.SYNC_BLOCKED_DELETE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncTrustedDelete: (payload: { id: string }) => createAction(SpamActionNames.SYNC_TRUSTED_DELETE, payload),
};

export type SpamAction = ActionsUnion<typeof SpamActions>;
